import React from "react";
import "../Services.css";
import EstateImage from "../../resources/estate-planning.jpg"; // Add the image path here

const EstatePlanning = () => {
  return (
    <div className="services-page-container">
      <img className="services-img" src={EstateImage} alt="Estate Guidance" />
      <h1 className="services-heading">Estate Guidance</h1>
      <p className="services-text">
        Everyone wants to provide and protect those they love, and estate
        guidance is an essential part of ensuring this. Not only does estate
        guidance help you protect your assets during your lifetime, but it also
        ensures that your loved ones can enjoy your assets after you're gone.
        Without proper estate guidance, your loved ones could face legal and
        financial difficulties when it comes to managing your estate. At{" "}
        <b className="services-bold">United Investment Point</b>, we specialize
        in helping you plan your estate, ensuring that your wishes are carried
        out according to your specific desires, minimizing potential conflicts
        and complications.
      </p>

      {/* YouTube Video Placeholder */}
      {/* <div className="video-container"> */}
      {/*     <iframe */}
      {/*         width="100%" */}
      {/*         height="100%" */}
      {/*         src="https://www.youtube.com/embed/2OJh0SDDtvY" // Replace with your video URL */}
      {/*         title="Estate Guidance Video" */}
      {/*         allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" */}
      {/*         allowFullScreen */}
      {/*     ></iframe> */}
      {/* </div> */}

      <h2 className="services-subheading">What is Estate Guidance?</h2>
      <p className="services-text">
        Estate guidance is the process of arranging for the management and
        distribution of your assets in the event of your death or
        incapacitation. It includes creating a will, establishing trusts,
        assigning powers of attorney, and designating beneficiaries for various
        assets. Proper estate guidance can minimize taxes, ensure your wishes
        are followed, and reduce the burden on your loved ones.
      </p>

      <h2 className="services-subheading">Our Estate Guidance Services</h2>
      <p className="services-text">
        At <b className="services-bold">United Investment Point</b>, we provide
        a range of estate guidance services tailored to your unique needs. Our
        services include:
      </p>
      <ul className="services-text-list">
        <li>
          <b>Will Drafting and Execution:</b> We help you draft a legally
          binding will and assist in its execution to ensure that your estate is
          distributed as you wish.
        </li>
        <li>
          <b>Trust Creation:</b> We offer guidance on setting up revocable and
          irrevocable trusts to protect your assets and minimize estate taxes.
        </li>
        <li>
          <b>Power of Attorney:</b> We assist in appointing someone you trust to
          handle your affairs if you become incapacitated, ensuring that your
          financial and legal matters are managed smoothly.
        </li>
        <li>
          <b>Beneficiary Designations:</b> We help you designate beneficiaries
          for various assets, including life insurance policies and retirement
          accounts, to ensure a smooth transfer of wealth.
        </li>
        <li>
          <b>Tax Guidance:</b> We provide tax optimization strategies to reduce
          the estate taxes your heirs may have to pay, ensuring more of your
          assets go to your loved ones.
        </li>
      </ul>

      <h2 className="services-subheading">Why Is Estate Guidance Important?</h2>
      <p className="services-text">
        Estate guidance is essential because it helps ensure your loved ones are
        taken care of after your passing. Without a clear estate plan, your
        assets could be distributed according to state law, potentially creating
        confusion, disputes, or unnecessary tax liabilities. Effective estate
        guidance also helps protect your assets from creditors, ensures the
        proper care of dependents, and provides peace of mind that your wishes
        will be honored.
      </p>

      <h2 className="services-subheading">Benefits of Estate Guidance</h2>
      <p className="services-text">
        Estate guidance offers numerous benefits, including:
      </p>
      <ul className="services-text-list">
        <li>
          <b>Peace of Mind:</b> Knowing that your estate will be handled
          according to your wishes gives you peace of mind.
        </li>
        <li>
          <b>Tax Efficiency:</b> By carefully planning your estate, you can
          minimize estate taxes, ensuring that your beneficiaries receive the
          maximum benefit.
        </li>
        <li>
          <b>Asset Protection:</b> Proper estate guidance helps protect your
          assets from creditors, ensuring they are preserved for your loved
          ones.
        </li>
        <li>
          <b>Care for Dependents:</b> You can specify how you want your
          dependents to be cared for and ensure that their financial needs are
          met.
        </li>
        <li>
          <b>Minimized Legal Complications:</b> A clear estate plan reduces the
          chances of disputes among heirs and ensures your estate is
          administered smoothly.
        </li>
      </ul>

      <h2 className="services-subheading">How We Can Help You</h2>
      <p className="services-text">
        At <b className="services-bold">United Investment Point</b>, we help you
        create an estate plan that addresses all your financial, personal, and
        legal concerns. Our team works closely with your attorneys, accountants,
        and other guides to ensure that your estate plan is comprehensive,
        effective, and legally sound. We help you navigate complex estate laws
        and provide strategies to protect your wealth and legacy.
      </p>
    </div>
  );
};

export default EstatePlanning;
